import { combineReducers } from '@reduxjs/toolkit';
import {
  emptyDeinVerbandApi,
  emptyOpenPlzApi,
  emptyPreflightApi
} from 'src/api/empty-api';
import { getStreamApi } from 'src/api/getstream-api';

export const rootReducer = combineReducers({
  [emptyDeinVerbandApi.reducerPath]: emptyDeinVerbandApi.reducer,
  [emptyOpenPlzApi.reducerPath]: emptyOpenPlzApi.reducer,
  [emptyPreflightApi.reducerPath]: emptyPreflightApi.reducer,
  [getStreamApi.reducerPath]: getStreamApi.reducer
});
